


















import { Component, Prop, Vue } from 'vue-property-decorator';
import meansPackageApi from '@/api/meansPackage';
import {
  Icon, Button, Toast, Image,
} from 'vant';
import { MeansReport } from './types';

@Component({
  components: {
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Image.name]: Image,
  },
})
export default class FooterC extends Vue {
  @Prop({}) meansReport!: MeansReport;

  @Prop() operatorSource!: String;

  goodJobSuccess: Boolean = true

  src: String = 'http://p0.meituan.net/scarlett/de76ff9e6e08a68fd837e41246a7e7f43227.png'

  // 点赞事件上报
  goodJobConfirm() {
    if (this.operatorSource !== 'BD') {
      this.goodJob();
    }
  }

  async goodJob() {
    const event = 'BROWSER_GIVE_LIKE';
    const { browserSource, leafKey, id } = this.meansReport;
    if (!this.goodJobSuccess) return;
    const { error, data }: ApiResponse.MDPData = await meansPackageApi.meansPackageReport(event, browserSource, leafKey, id);
    if (!error && data) {
      this.goodJobSuccess = false;
      this.src = 'http://p0.meituan.net/scarlett/24b072c12bf89b83e9edd190696c04fd1696.png';
      Toast.success('点赞成功！');
    } else if (error) {
      this.goodJobSuccess = true;
      Toast.fail(error.msg);
    }
  }
}
